import React from 'react';
import { getUILoc } from '../../utils/cardUtils.js';

const YonotsuneMenu = ({ onStart, onShowAchievements, onShowRecords, onShowHelp, onBack, toast, hasActiveRun, matchedCount }) => {
  return (
    <div className="yonotsune-screen main-menu">
      <div className="bg-glitch-overlay"></div>
      <h1 className="yonotsune-title">{getUILoc('YONOTSUNE.TITLE')}</h1>
      <p className="yonotsune-subtitle">{getUILoc('YONOTSUNE.SUBTITLE')}</p>

      <div className="menu-box">
        <button className="yonotsune-btn start-btn" onClick={onStart}>
          <span className="btn-effect"></span>
          {hasActiveRun 
            ? getUILoc('YONOTSUNE.RESUME_RUN', { count: matchedCount + 1 }) 
            : getUILoc('YONOTSUNE.START_RUN')
          }
        </button>
        <button className="yonotsune-btn" onClick={onShowRecords}>
          {getUILoc('YONOTSUNE.RECORDS.TITLE') || '検証記録'}
        </button>
        <button className="yonotsune-btn" onClick={onShowAchievements}>
          {getUILoc('YONOTSUNE.ACHIEVEMENTS')}
        </button>
        <button className="yonotsune-btn" onClick={onShowHelp}>
          {getUILoc('YONOTSUNE.HELP')}
        </button>
        <button className="yonotsune-btn back-btn" onClick={onBack}>
          {getUILoc('YONOTSUNE.BACK_TO_TITLE')}
        </button>
      </div>

      {toast && (
        <div className="achievement-toast">
          <div className="toast-glow"></div>
          <div className="toast-icon">🏆</div>
          <div className="toast-content">
            <h4>{getUILoc('YONOTSUNE.ACHIEVEMENT_UNLOCKED')}</h4>
            <h3>{toast.name}</h3>
            <p>{toast.desc}</p>
          </div>
        </div>
      )}
    </div>
  );
};

export default YonotsuneMenu;


